import React, { useEffect, useMemo, useRef, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Table from "../../../components/Table/Table"
import LinearProgress from "@mui/material/LinearProgress"
import axios from "axios"
import { Link } from "react-router-dom"
import Button from "@mui/material/Button"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import { logOut } from "../../../utils/logOut"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import TablePagination from "@mui/material/TablePagination"
import { Fade, Switch, Typography } from "@mui/material"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"
import { useSelector } from "react-redux"
import { useLocation, useSearchParams } from "react-router-dom";

export default function SynthAudioFragments() {
    const dispatch = useAppDispatch()
    const [tableData, setTableData] = useState([])
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    const [loading, setLoading] = useState(false)
    const [conversationtemplates, setConversationtemplates] = useState([])
    const [synthVoices, setSynthVoices] = useState([])
    const [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get("id");

    // флаг, чтобы применить id только один раз за жизнь компонента
    const idAppliedRef = useRef(false);

    const [filterParams, setFilterParams] = useState(localStorage.getItem('synthaudiofragments_filter') ? JSON.parse(localStorage.getItem('synthaudiofragments_filter') || '{}') : {
        conversationtemplate: '',
        sort: 'datetimeproduceddown',
        voice: '',
        text: '',
        onlyoriginal: '0',
    })

    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        dispatch(setCurrentPage(`Synthesized audio fragments`))
    }, [dispatch]);

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )


    function saveFilterData() {
        localStorage.setItem('synthaudiofragments_filter', JSON.stringify(filterParams))
    }

    //Get prerecordedspeech data
    // async function fetchData(params: object = {}) {
    //     setLoading(true)
    //     try {
    //         const response = await axios.get(`https://cardgarantsales.com/restapi/synthesizedspeech`, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 "Authorization": "Bearer " + localStorage.getItem('access_token')
    //             }, params: { ...params, startRow, maxRows, calculatetotalcount: true }
    //         })
    //         if (response.data !== null) {
    //             if (typeof (response.data) === 'object') {
    //                 setTotalRows(+response.data[0].totalcount)
    //                 setTableData(response.data.slice(1))
    //             }
    //             else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
    //         }

    //         console.log(response.data);

    //         setLoading(false)
    //     } catch (error: any) {
    //         console.log(error);
    //         if (error.code === "ERR_BAD_REQUEST") {
    //             logOut(dispatch)
    //         }
    //         else if (error.code === "ERR_NETWORK") {
    //             showSnackbar('ERROR NETWORK', 'error')
    //         }
    //         setLoading(false)
    //     }
    // }



    async function fetchSynthIDData(id: any) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/synthesizedspeech/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: {}
            })

            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    return {
                        ...filterParams,
                        voice: response.data[0].voice,
                        text: response.data[0].text,
                    }
                }

                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

      async function fetchData() {
        setLoading(true);
        try {
            let params: any = { ...filterParams, startRow, maxRows, calculatetotalcount: true };

            if (id && !idAppliedRef.current) {
                const newparams = await fetchSynthIDData(id);
                if (newparams) {
                    params = { ...newparams, startRow, maxRows, calculatetotalcount: true };
                    setFilterParams(newparams);
                    saveFilterData();

                    // помечаем, что id уже применён
                    idAppliedRef.current = true;

                    // УДАЛЯЕМ id корректно, через react-router
                    const next = Object.fromEntries(searchParams.entries());
                    delete next.id;
                    setSearchParams(next, { replace: true });
                }
            }

            const response = await axios.get(
                `https://cardgarantsales.com/restapi/synthesizedspeech`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("access_token"),
                    },
                    params,
                }
            );

            if (response.data !== null && typeof response.data === "object") {
                setTotalRows(+response.data[0].totalcount);
                setTableData(response.data.slice(1));
            } else {
                showSnackbar('ERROR NETWORK', 'error')
            }
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") logOut(dispatch);
            else if (error.code === "ERR_NETWORK") showSnackbar("ERROR NETWORK", "error");
        } finally {
            setLoading(false);
        }
    }
    


    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data.filter((el: any) => el.showsetuptopartner == '1'));
            setConversationtemplates(accesslevel != 5 ? response.data.filter((el: any) => el.showsetuptopartner == '1') : response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get voices for Select field
    async function getSynthVoices(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/synthvoice`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setSynthVoices(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //on load - fetch data
    useEffect(() => {
        setTimeout(() => fetchData(), 0)
        getConversationtemplates()
        getSynthVoices()
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filterParams])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);
    //exclusion of unnecessary table renderers
    const memoizedTable = useMemo(() => <SimplifiedTable rows={tableData} page={'synthaudiofragment'} fetchDataUpdate={() => setTimeout(() => fetchData(), 0)} />, [tableData]);

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column', mr: 1 }}>
            <Box sx={{ mb: 3, alignItems: "center", display: 'flex', width: "100vw", justifyContent: "center" }}>
                {/* <Link to='/prerecordedaudiosnippet' state={{ type: 'add' }}>
                    <Button size="small" sx={{ mr: '10vw', width: 220 }} variant="outlined">Add Prerecorded Snippet</Button>
                </Link> */}
                <Box sx={{ display: "flex", flexWrap: 'wrap', alignItems: "center", gap: 2 }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Sort'} /></InputLabel>
                        <Select sx={{ width: '12vw', minWidth: 223 }} labelId="simple-select-label" value={filterParams.sort} onChange={(e) => setFilterParams({ ...filterParams, sort: e.target.value })} variant="outlined" size="small" label={<TranslatedText text={'Sort'} />} >
                            <MenuItem selected value={''}><TranslatedText text={'Default'} /> (^<TranslatedText text={'Conversation Template'} /> + v<TranslatedText text={'Transcript'} />)</MenuItem>
                            <MenuItem value={'datetimeproducedup'}>^<TranslatedText text={'date'} />/<TranslatedText text={'time'} /></MenuItem>
                            <MenuItem value={'datetimeproduceddown'}>v<TranslatedText text={'date'} />/<TranslatedText text={'time'} /></MenuItem>
                            <MenuItem value={'audiolengthup'}>^<TranslatedText text={'Duration'} /></MenuItem>
                            <MenuItem value={'audiolengthdown'}>v<TranslatedText text={'Duration'} /></MenuItem>
                            <MenuItem value={'voiceup'}>^<TranslatedText text={'voice'} /></MenuItem>
                            <MenuItem value={'voicedown'}>v<TranslatedText text={'voice'} /></MenuItem>
                            <MenuItem value={'textup'}>^<TranslatedText text={'Text'} /></MenuItem>
                            <MenuItem value={'textdown'}>v<TranslatedText text={'Text'} /></MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, conversationtemplate: e.target.value })} value={filterParams.conversationtemplate} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
                            <MenuItem value={''}><TranslatedText text={'Not Selected'} /></MenuItem>
                            {
                                conversationtemplates.map((el: any) => (
                                    <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Voice'} /></InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setFilterParams({ ...filterParams, voice: e.target.value })} value={filterParams.voice} variant="outlined" size="small" label={<TranslatedText text={'Voice'} />} >
                            <MenuItem value={''}><TranslatedText text={'Not Selected'} /></MenuItem>
                            {
                                synthVoices.map((el: any) => (
                                    <MenuItem key={el.id} value={el.voicecode}>{el.voicename}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <TextField key={filterParams.text+1} defaultValue={filterParams.text} onBlur={(e) => setFilterParams({ ...filterParams, text: e.target.value })} sx={{ minWidth: 223 }} variant="outlined" size="small" label={<TranslatedText text={'Text'} />} />
                    <Box sx={{ display: "flex", alignItems: "center", border: 1, borderRadius: 1, borderColor: '#c4c4c4', color: '#686c77', paddingLeft: 1 }}>
                        <Typography><TranslatedText text={'Only original synthesis'} /></Typography>
                        <Switch onChange={(e) => setFilterParams({ ...filterParams, onlyoriginal: filterParams.onlyoriginal === '0' ? '1' : '0' })} checked={Boolean(+filterParams.onlyoriginal)} />
                    </Box>
                    <Button onClick={() => { fetchData(); saveFilterData() }} size="small" sx={{ mr: 1 }} variant="contained" ><TranslatedText text={'Apply'} /></Button>
                </Box>
                <Box></Box>
            </Box>
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>}
        </Box>
    )
}